export const TARGET_GNOME_LIST = [
  { value: "hg38", label: "Homo sapiens (hg38)" },
  { value: "hg19", label: "Homo sapiens (hg19)" },
  { value: "mm39", label: "Mus musculus	(mm39)" },
  { value: "mm10", label: "Mus musculus	(mm10)" },
];

export const PAM_TYPE = [
  { value: "NGG", label: "NGG" },
  { value: "NAG", label: "NAG" },
  { value: "NGA", label: "NGA" },
];

export const BSE_EDITOR_TYPE = [
  //{ label: "ABE", value: "abe", disabled: true },
  { label: "CBE", value: "cbe" },
];

export const CBE_TYPE = [
  { label: "Flexible Editor", value: "flexible" },
  { label: "Precision Editor", value: "precision" },
];

export const AUTO_COMPLETE_DISPLAY_KEYS = [
  "gene_id",
  "gene_symbol",
  "gene_alias",
];

export const PAM_FILTER_OPTIONS = [
  { label: "NGG", value: "NGG" },
  { label: "NON NGG", value: "NON NGG" },
];

export const STOP_CODON_KEYS = [
  "gene_id",
  "end",
  "start",
  "strand",
  "chromosome",
];

export const TARGET_TABLE_LABEL = [
  "offtargetZero",
  "offtargetOne",
  "offtargetTwo",
  "offtargetThree",
];
export const EXPORT_HEADERS: string[] = [
  "gRNA ID",
  "gRNA Sequence",
  "Target Coding Sequence",
  "Amino acid codon for Target Coding Sequence",
  "Edited Target Sequence",
  "Amino acid codon for Edited Target Sequence",
  "gRNA Start",
  "PAM",
  "gRNA Strand",
  "Mismatch-0",
  "Mismatch-1",
  "Mismatch-2",
  "Mismatch-3",
];

export const EXPORT_HEADERS_STOP_CODEN: string[] = [
  "gRNA ID",
  "gRNA Sequence",
  "Target Coding Sequence",
  "Amino acid codon for Target Coding Sequence",
  "Edited Target Sequence",
  "Amino acid codon for Edited Target Sequence",
  "PAM",
  "gRNA Strand",
  "Position of Stop Codon",
  "Mismatch-0",
  "Mismatch-1",
  "Mismatch-2",
  "Mismatch-3",
];

export const KEYS_TO_COLLECT_STOP_CODEN: string[] = [
  "gRNA_id",
  "crispr_target",
  "gRNA",
  "gRNA_codons",
  "base_edited_gRNA",
  "base_edited_gRNA_codons",
  "pam_type",
  "grna_strand",
  "stop_codon_position",
  "off_target_analysis",
];

export const KEYS_TO_COLLECT: string[] = [
  "gRNA_id",
  "crispr_target",
  "gRNA",
  "gRNA_codons",
  "base_edited_gRNA",
  "base_edited_gRNA_codons",
  "gRNA_start",
  "pam_type",
  "grna_strand",
  "off_target_analysis",
];

export const FONT_NAME = "Courier New";

export const REG_PAM_FILTER = "[A|T|C|G]GG|CC[A|G|T|C]";

export const ARR_LABELS = [
  "offtargetZero",
  "offtargetOne",
  "offtargetTwo",
  "offtargetThree",
];

export const DOWNLOAD_OPTIONS = [
  { label: "Design Primer(s) for Selected gRNA", value: "selectedPrimer" },
  { label: "Download Selected gRNA", value: "selected" },
  { label: "Download All gRNA", value: "all" },
];

export const GRAN_LENGTH = [
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
];

export const SUMMARY_HEADERS: string[] = [
  "gRNA ID",
  "Target Sequence",
  "0",
  "1",
  "2",
  "3",
];

export const PF_HEADERS: string[] = [
  "gRNA ID",
  "Target Sequence",
  "Chromsome",
  "gRNA Strand",
  "Off-target Strand",
  "Potential off-target sites",
  "Position of Mismatch",
  "Mismatch Count",
];

export const SUMMARY_KEY: string[] = [
  "gRNA_id",
  "gRNA",
  "offtargetZero",
  "offtargetOne",
  "offtargetTwo",
  "offtargetThree",
];

export const DETAILS_KEY: string[] = [
  "gRNA_id",
  "target_sequence",
  "chromsome",
  "strand",
  "off_target_strand",
  "potential_off_target_site",
  "position_of_mismatch",
  "mismatch_count",
];

export const PRIMER_DOWNLOAD_KEYS: string[] = [
  "primer_name",
  "targetSequence",
  "left_sequence",
  "right_sequence",
  "left_tm",
  "right_tm",
  "left_gc",
  "right_gc",
  "pcr_amplicon_size",
  "pcr_amplicon_sequence",
  "cutband_size",
];
export const PRIMER_DOWNLOAD_HEADER: string[] = [
  "Primer Name (gRNA ID)",
  "Target Coding Sequence",
  "Left Sequence",
  "Right Sequence",
  "Left TM",
  "Right TM",
  "Left GC",
  "Right GC",
  "PCR Amplicon Size",
  "PCR Amplicon Sequence",
  "Distance to PAM",
];
export const PRIMER_DOWNLOAD_HEADER_OFFTARGET: string[] = [
  "Primer Name (gRNA ID)",
  "Potential Off-Target Sequence",
  "Left Sequence",
  "Right Sequence",
  "Left TM",
  "Right TM",
  "Left GC",
  "Right GC",
  "PCR Amplicon Size",
  "PCR Amplicon Sequence",
  "Distance to PAM",
];
export const MAX_GRNA_FOR_PRIMER = 5;

// export const SEQ_VALIDATE_REGX = /(>[\w-, .:-\\(\\)]+\n)/;

export const SEQ_VALIDATE_REGX = /(>.+\n)/;
